<template>
  <icon-component v-bind="$props">
    <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M59.6226 34.2642L51.1698 42.717L46.6328 38.189L42.717 34.2642L51.1698 25.8113L59.6226 34.2642Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.0755 27.3962L47.4717 20H25.8113C22.6018 20 20 22.6018 20 25.8113V70.1887C20 73.3982 22.6018 76 25.8113 76H70.1887C73.3982 76 76 73.3982 76 70.1887V25.8113C76 22.6018 73.3982 20 70.1887 20H54.8679L62.2641 27.3962H68.6038V36.2548L55.9511 48.9074L61.181 54.1373L68.6038 46.7146V68.6038H65.7331L34.499 37.3697L27.3962 44.4724V27.3962H40.0755ZM27.3962 68.6038V54.9322L34.499 47.8295L55.2732 68.6038H27.3962Z"
        fill="currentColor"
      />
    </svg>
  </icon-component>
</template>

<script>
  import IconComponent from './IconComponent.vue';

  export default {
    components: {
      IconComponent,
    },
    extends: IconComponent,
  };
</script>
